// extracted by mini-css-extract-plugin
export default {"TextCell":"XncZ0vVh","wrapper":"BeZbuqHF","value":"cGpr9oHo"};